import { render, staticRenderFns } from "./SiteNavDesktop.vue?vue&type=template&id=5c5ff2d0&scoped=true&lang=pug&"
import script from "./SiteNavDesktop.vue?vue&type=script&lang=js&"
export * from "./SiteNavDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavDesktop.vue?vue&type=style&index=0&id=5c5ff2d0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ff2d0",
  null
  
)

export default component.exports